








































































































































// Import vendors ----------------------------------------------------------------------------------
import { defineComponent, computed, reactive } from '@vue/composition-api';
// Import components -------------------------------------------------------------------------------
import ChartEvolutionRehabSide from '@/components/charts/evolution/rehab/ChartEvolutionRehabSide.vue';
// Import helpers ----------------------------------------------------------------------------------
import { getUnit, EValueTypeUnit } from '@/helpers/helped-chart-functions.helper';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'ChartEvolutionGroupsRehabSingleHop',
  components: {
    ChartEvolutionRehabSide
  },
  props: {
    values: {
      type: Object,
      required: true
    },
    relative: {
      type: Boolean,
      required: true
    }
  },
  setup(properties) {
    const aggregates = computed(() => properties.values.data.aggregates);
    const manifest = computed(() => properties.values.analysisManifests);

    const unit = reactive({
      totaldistance: getUnit(EValueTypeUnit.TotalDistance),
      jumpheight: getUnit(EValueTypeUnit.JumpHeight)
    });

    const modes = reactive({
      jumpProfile: true,
      standard: false,
      advanced: false
    });

    return {
      aggregates,
      manifest,
      modes,
      unit
    };
  }
});
